export default __webpack_public_path__ + "static/home-1200w-84b8c065138efa1618c8a749e24fc155.jpg";